import React from 'react';
import { GuideContent } from '../../../../../interfaces/stay-guide';
import { t } from '../../../../onboarding/stay/stay-strings';
import { telHref } from './guide-format';
import { ButtonRow, Help, Muted, PrimaryAnchor, SecondaryAnchor, SectionHeading } from './guide.styled';

const L = 'en' as const;

/**
 * "NEED HELP?" — the end of every guide page (plan S7.7). Who to ask about the
 * stay, and the emergency number (the listing's, or 112 for an EU listing the
 * server filled in). A button only when there is a number to call; the second
 * sentence only when there is an emergency number.
 *
 * It ends the page rather than being pinned to the bottom, so it needs no
 * safe-area inset of its own — the frame's last padding clears the home bar.
 */
export const GuideHelpStrip: React.FC<{ guide: GuideContent }> = ({ guide }) => {
  const host = guide.host_name || t(L, 'guide.yourHost');
  const emergency = (guide.emergency_phone || '').trim();
  const hostTel = telHref(guide.host_phone);
  const emergencyTel = telHref(emergency);
  const sentence = emergency
    ? `${t(L, 'guide.helpBody', { host })} ${t(L, 'guide.helpEmergency', { number: emergency })}`
    : t(L, 'guide.helpBody', { host });

  return (
    <Help aria-labelledby="guide-help-title" data-guide-help="">
      <SectionHeading id="guide-help-title">{t(L, 'guide.helpTitle')}</SectionHeading>
      <Muted>{sentence}</Muted>
      {hostTel || emergencyTel ? (
        <ButtonRow>
          {hostTel ? <SecondaryAnchor href={hostTel}>{t(L, 'guide.callHostButton')}</SecondaryAnchor> : null}
          {emergencyTel ? (
            <PrimaryAnchor href={emergencyTel}>{t(L, 'guide.emergencyButton', { number: emergency })}</PrimaryAnchor>
          ) : null}
        </ButtonRow>
      ) : null}
    </Help>
  );
};
